import React from "react"
import { useTeaserStatistic } from "./useTeaserStatistic"
import omit from "lodash/omit"

const formatters = {
  /**
   * @param {string} n
   */
  revenue: n => `€${n.toLocaleString()}`,
}

const nameMap = {
  revenue: "Umsatz",
  clickers: "Clicks",
  outclicks: "Outclicks",
  sales: "Sales",
}

const scopes = {
  today: "Heute",
  alltime: "Gesamt",
}

const MiniStatLabel = ({ title, value, ...props }) => (
  <label {...props}>
    {title}
    {` `}
    {value}
  </label>
)

const List = ({ stats, Item = MiniStatLabel, itemProps }) =>
  stats.map(stat =>
    React.isValidElement(stat)
      ? stat
      : React.createElement(stat.Item || Item, {
          ...itemProps,
          ...omit(stat, "Item", "name"),
        })
  )

const makeListFromStats = statsObject =>
  statsObject &&
  Object.entries(statsObject).map(([key, val]) => {
    const [scope, name] = key.split("_")
    return {
      name,
      title: `${nameMap[name]} (${scopes[scope]})`,
      value: formatters[name] ? formatters[name](val) : val.toLocaleString(),
    }
  })

/**
 * Renders teaser statistics around a component.
 * The only required field is teaserId
 * You can add custom Statistics using the `stats` prop.
 *
 * @param {{
 *  teaserId: number,
 *  className?: string,
 *  stats?: Array<
 *    {
 *      name:string,
 *      title:string,
 *      value:string,
 *    } |
 *    {
 *      Item: React.ElementType
 *    } |
 *     React.ReactNode
 *  >,
 *  children?: React.ReactNode
 * }} param0
 */
export const TeaserStatisticsContainer = ({ teaserId, ...props }) => {
  const { status, ...data } = useTeaserStatistic(teaserId) || {}
  const stats = [...makeListFromStats(data), ...(props.stats || [])]

  const result = [
    status === "loaded" || status === "not_found" ? (
      <div
        key="stats"
        className={`teaser-statistics-wrapper ${props.className || ""}`}
      >
        <MiniStatLabel
          title="ID"
          value={teaserId}
          className="label label-primary text-xs"
        />
        {status === "not_found" && (
          <MiniStatLabel
            title="Nichts gefunden"
            className="label label-danger text-xs"
          />
        )}
        <List
          stats={stats}
          itemProps={{ className: "label label-default text-xs" }}
        />
      </div>
    ) : null,
    props.children,
  ]

  return result
}
